import { MapPin, IndianRupee, UserCheck, ShieldCheck, Zap, Layers } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const REASONS = [
  { icon: MapPin, title: "On-Ground Presence in India", desc: "Our team is at the factory, not on a phone call — problems are seen and solved at source." },
  { icon: IndianRupee, title: "Direct Factory Pricing", desc: "You buy from the manufacturer, not through layers of trading intermediaries." },
  { icon: UserCheck, title: "Single Point of Accountability", desc: "One contact, one contract and one invoice across multiple suppliers and categories." },
  { icon: ShieldCheck, title: "Risk & Compliance Control", desc: "Vetted vendors, milestone-based payments and documented inspection at every stage." },
  { icon: Zap, title: "Faster Sampling & Lead Times", desc: "Established vendor relationships shorten development and reorder cycles." },
  { icon: Layers, title: "Multi-Category Consolidation", desc: "Combine several product lines into a single container and a single shipment." },
];

export const WhyUs = () => (
  <section id="why-us" className="relative py-28 lg:py-40 bg-[#F4F7FC]" data-testid="why-us-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal>
        <SectionTag index="06" label="Our Value" />
      </Reveal>
      <Reveal>
        <h2 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0A1B33] max-w-3xl mb-20" data-testid="why-us-heading">
          Why clients <span className="text-[#2E7FE0]">partner with us.</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.06} className="h-full">
            <div
              className="group glass-panel rounded-2xl p-10 h-full hover:border-[#2E7FE0]/50 transition-colors duration-500"
              data-testid={`why-us-card-${i}`}
            >
              <span className="font-mono2 text-xs text-[#54678A]/50 block mb-8">
                {String(i + 1).padStart(2, "0")}
              </span>
              <r.icon className="w-8 h-8 text-[#2E7FE0] mb-6 transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="font-display font-semibold text-xl text-[#0A1B33] mb-4 leading-snug">{r.title}</h3>
              <p className="text-[#54678A] text-sm leading-relaxed">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
